import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, PageEvent, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { GatewayService } from '../../gateway.service';
import { LocalSaveService } from '../../services/local-save-service.service';

const SUPERVISOR_IDROLES = [3, 10, 15, 16];

@Component({
    selector: 'app-historial-nuevas-ordenes',
    templateUrl: './historial-nuevas-ordenes.component.html',
    styleUrls: ['./historial-nuevas-ordenes.component.scss']
})
export class HistorialNuevasOrdenesComponent implements OnInit {

    displayedColumns = ['expand', 'SERVICE_ORDER_NO', 'RAISED_DATE', 'ACCT_NO', 'estado_actual', 'total_pasos'];
    dataSource = new MatTableDataSource<any>([]);
    total = 0;
    page = 1;
    pageSize = 50;
    isLoading = false;

    filterOrden = '';
    filterCuenta = '';
    filterDept = '';

    expandedElement: any = null;

    @ViewChild(MatPaginator, { static: false } as any) paginator: MatPaginator;

    puedeVer = false;

    constructor(
        private gateway: GatewayService,
        private snackBar: MatSnackBar,
        private router: Router,
        private localSave: LocalSaveService
    ) {}

    private _tienePermiso(modulo: string, tipo: string = 'ver'): boolean {
        const user = this.localSave.get('usuarioPGV');
        if (!user || !user.permisos) return false;
        const perm = user.permisos.find((p: any) => p.modulo === modulo);
        if (!perm) return false;
        return perm['permiso_' + tipo] === 1;
    }

    ngOnInit() {
        const user = this.localSave.get('usuarioPGV');
        const esSuperAdmin = user && user.esSuperAdmin;
        const esRolSupervisor = user && SUPERVISOR_IDROLES.includes(Number(user.idrol));
        this.puedeVer = !!(esSuperAdmin || esRolSupervisor || this._tienePermiso('ORDENES_SIN_CITA'));
        if (!this.puedeVer) {
            this.router.navigate(['/home']);
            return;
        }
        this.cargar();
    }

    cargar() {
        this.isLoading = true;
        this.expandedElement = null;
        const payload = {
            page: this.page,
            pageSize: this.pageSize,
            service_order_no: this.filterOrden.trim() || null,
            acct_no: this.filterCuenta.trim() || null,
            department_code: this.filterDept.trim() || null
        };
        this.gateway.get('historialEstadosListar', payload)
            .then((res: any) => {
                this.isLoading = false;
                if (!res || res.response !== 1) {
                    const msg = res && res.message ? res.message : 'Error al cargar';
                    this.snackBar.open(msg, 'OK', { duration: 3000 });
                    this.dataSource = new MatTableDataSource([]);
                    this.total = 0;
                    return;
                }
                this.dataSource = new MatTableDataSource(res.rows || []);
                this.total = res.total || 0;
            })
            .catch((err: any) => {
                this.isLoading = false;
                console.error('[historial-nuevas-ordenes] error:', err);
                this.snackBar.open('Error de red al cargar historial', 'OK', { duration: 3000 });
            });
    }

    onPage(ev: PageEvent) {
        this.page = ev.pageIndex + 1;
        this.pageSize = ev.pageSize;
        this.cargar();
    }

    onBuscar() {
        this.page = 1;
        if (this.paginator) this.paginator.firstPage();
        this.cargar();
    }

    onLimpiar() {
        this.filterOrden = '';
        this.filterCuenta = '';
        this.filterDept = '';
        this.page = 1;
        if (this.paginator) this.paginator.firstPage();
        this.cargar();
    }

    toggleExpand(element: any) {
        this.expandedElement = this.expandedElement === element ? null : element;
    }

    getUltimoEstado(element: any): string {
        if (!element.estados || element.estados.length === 0) return '—';
        const ultimo = element.estados[element.estados.length - 1];
        if (!ultimo || !ultimo.DEPARTMENT_CODE) return '—';
        return ultimo.es_wfm ? this.getWfmLabel(ultimo.DEPARTMENT_CODE) : ultimo.DEPARTMENT_CODE;
    }

    esUltimoEstadoWfm(element: any): boolean {
        if (!element.estados || element.estados.length === 0) return false;
        return !!element.estados[element.estados.length - 1].es_wfm;
    }

    getWfmLabel(processId: string): string {
        const labels = {
            'CANCEL_ORDER': 'CANCEL',
            'REJECT_ORDER': 'REJECT',
            'SUSPEND_ORDER': 'SUSPEND',
            'SIGNOFF_ORDER': 'SIGNOFF'
        };
        return labels[processId] || processId;
    }
}
